import axios from 'axios';
import isFinite from 'lodash/isFinite';

const state = {
    enterprises: [],
    areas: [],
    segments: [],
    groups: [],
    enterpriseId: null,
    areaId: null,
    segmentId: null,
    groupId: null,
    date: '',
    end_date: '',
    payrollTypes: {},
    payrollType: null,
    loadingEnterprises: false,
    loadingAreas: false,
    loadingSegments: false,
    loadingGroups: false,
};

const getters = {
    payrollTypeOptions: state => {
        return [{ value: null, text: 'Seleccionar' }].concat(
            Object.keys(state.payrollTypes).map(pt => ({value: pt, text: state.payrollTypes[pt]}))
        );
    },
    enterpriseOptions: state => {
        return [{ value: null, text: 'Seleccionar' }].concat(
            state.enterprises.map(p => {
                return { value: p.id, text: p.name }
            })
        );
    },
    areaOptions: state => {
        return [{ value: null, text: 'Seleccionar' }].concat(
            state.areas.map(p => {
                return { value: p.id, text: p.name }
            })
        );
    },
    segmentOptions: state => {
        return [{ value: null, text: 'Seleccionar' }].concat(
            state.segments.map(p => {
                return { value: p.id, text: p.name }
            })
        );
    },
    groupOptions: state => {
        return [{ value: null, text: 'Seleccionar' }].concat(
            state.groups.map(p => {
                return { value: p.id, text: p.name }
            })
        );
    },
    enterprise: state => {
        if (state.enterpriseId !== null) {
            return state.enterprises.find(e => e.id == state.enterpriseId);
        }

        return null;
    }
};

const mutations = {
    setDate(state, date) {
        state.date = date;
    },
    setEndDate(state, endDate) {
        state.end_date = endDate;
    },
    setPayrollTypes(state, payrollTypes) {
        state.payrollTypes = payrollTypes;
    },
    setPayrollType(state, payrollType) {
        state.payrollType = payrollType;
    },
    setEnterprises(state, enterprises) {
        state.enterprises = enterprises;
    },
    setAreas(state, areas) {
        state.areas = areas;
    },
    setSegments(state, segments) {
        state.segments = segments;
    },
    setGroups(state, groups) {
        state.groups = groups;
    },
    setEnterpriseId(state, id) {
        state.enterpriseId = id;
    },
    setAreaId(state, id) {
        state.areaId = id;
    },
    setSegmentId(state, id) {
        state.segmentId = id;
    },
    setGroupId(state, id) {
        state.groupId = id;
    }
};

const actions = {
    loadEnterprises({state, commit, dispath}, { payrollType, reset = true }) {
        state.loadingEnterprises = true;

        axios.get(`/api/payroll-types/${payrollType}/enterprises`, {
            params: {
                date: state.date
            }
        })
            .then(res => {
                commit('setEnterprises', [...res.data]);

                console.log('finding in ', state.enterprises)
                if (state.enterprises.findIndex(e => e.id == state.enterpriseId) === -1)
                    commit('setEnterpriseId', null);

                if (reset) {
                    commit('setAreas', []);
                    commit('setSegments', []);
                    commit('setGroups', []);
                    commit('setAreaId', null);
                    commit('setSegmentId', null);
                    commit('setGroupId', null);
                }

                state.loadingEnterprises = false;
            });
    },
    loadAreas({state, commit}, { enterprise, reset = true }) {
        state.loadingAreas = true;

        axios.get(`/api/enterprises/${enterprise}/areas`)
            .then(res => {
                commit('setAreas',  [...res.data]);

                if (reset) {
                    commit('setSegments', []);
                    commit('setGroups', []);
                    commit('setAreaId', null);
                    commit('setSegmentId', null);
                    commit('setGroupId', null);
                }

                state.loadingAreas = false;
            })
    },
    loadSegments({state, commit}, { area, reset = true }) {
        state.loadingSegments = true;

        axios.get(`/api/areas/${area}/segments`)
            .then(res => {
                commit('setSegments',  [...res.data]);

                if (reset) {
                    commit('setGroups', []);
                    commit('setSegmentId', null);
                    commit('setGroupId', null);
                }

                state.loadingSegments = false;
            });
    },
    loadGroups({state, commit}, { segment, reset = true }) {
        state.loadingGroups = true;
        axios.get(`/api/segments/${segment}/groups`)
            .then(res => {
                commit('setGroups',  [...res.data]);

                if (reset) {
                    commit('setGroupId', null);
                }

                state.loadingGroups = false;
            })
    },
    init({ commit, dispatch }) {
        commit('setDate', date)
        commit('setEndDate', end_date)
        commit('setPayrollTypes', payrollTypes)

        if (payrollType) {
            commit('setPayrollType', payrollType)
            dispatch('loadEnterprises', { payrollType, reset: false });
        }

        if (typeof enterprise !== 'undefined' && isFinite(parseInt(enterprise))) {
            commit('setEnterpriseId', enterprise)
            dispatch('loadAreas', { enterprise, reset: false });
        }

        if (typeof area !== 'undefined' && isFinite(parseInt(area))) {
            commit('setAreaId', area)
            dispatch('loadSegments', { area, reset: false });
        }

        if (typeof segment !== 'undefined' && isFinite(parseInt(segment))) {
            commit('setSegmentId', segment)
            dispatch('loadGroups', { segment, reset: false })
        }

        if (typeof group !== 'undefined' && isFinite(parseInt(group))) {
            commit('setGroupId', group)
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
